import React, { useRef } from 'react'

const Content = (props) => {
	const propContent = useRef(null)

	const toggleMenu = () => {
		props.toggleMenuCallback()
	}

	return (
		<div onClick={() => toggleMenu} ref={propContent}>
			{props.body}
		</div>
	)
}

export default Content